module.exports = __webpack_public_path__ + "img/beaver.3b27b5de.svg";